export default function speaker(state = {
  allSpeakers: [],
  speaker: {}
}, action) {
  switch (action.type) {
    case "SPEAKER_CREATED":
      return state
    case "SPEAKERS_FETCHED":
      return Object.assign({}, state, {
        allSpeakers: action.payload.speakers,
        speaker: {}
      })
    case "EVENT_FETCHED":
      return Object.assign({}, state, {
        allSpeakers: action.payload.speakers
      })
    case "SPEAKER_FETCHED":
      return Object.assign({}, state, {
        speaker: action.payload.speaker
      })
    default:
      return state
  }
}
